/**
 * Judge.me brand color overrides — judgeme-color-overrides.js
 * Runs only after lazy-loaded reviews inject (baybee:judgeme-reviews-loaded).
 * CSS in product-reviews.css handles static elements; this covers dynamic re-renders.
 */
(function () {
  'use strict';

  var BRAND = '#7ac943';
  var DEBOUNCE_MS = 500;
  var OBSERVER_MAX_MS = 15000;

  function overrideDropdownColors(root) {
    if (!root) return;

    root.querySelectorAll('.jdgm-sort-dropdown-wrapper select, .jdgm-rev-widg__sort-wrapper select').forEach(function (select) {
      select.style.accentColor = BRAND;
    });

    root.querySelectorAll('.jdgm-sort-dropdown, .jdgm-rev-widg__sort-wrapper button, .jdgm-rev-widg__sort-wrapper a').forEach(function (el) {
      if (el.classList.contains('jdgm-curt')) {
        el.style.color = BRAND;
        el.style.borderColor = BRAND;
      }
    });
  }

  function overrideAllColors(root) {
    if (!root) return;

    root.querySelectorAll('.jdgm-star.jdgm--on').forEach(function (star) {
      star.style.color = BRAND;
    });

    root.querySelectorAll('.jdgm-histogram__bar-content').forEach(function (bar) {
      bar.style.background = BRAND;
    });

    root.querySelectorAll('.jdgm-write-rev-link, .jdgm-ask-question-btn, .jdgm-paginate__page.jdgm-curt').forEach(function (el) {
      el.style.color = BRAND;
    });

    root.querySelectorAll('.jdgm-submit-rev, .jdgm-btn--solid').forEach(function (btn) {
      btn.style.backgroundColor = BRAND;
      btn.style.borderColor = BRAND;
    });

    overrideDropdownColors(root);
  }

  function watchDynamicUpdates(root) {
    var debounceTimer;
    var observer = new MutationObserver(function () {
      window.clearTimeout(debounceTimer);
      debounceTimer = window.setTimeout(function () {
        overrideAllColors(root);
      }, DEBOUNCE_MS);
    });

    observer.observe(root, { childList: true, subtree: true, attributes: true, attributeFilter: ['class', 'style'] });

    window.setTimeout(function () {
      observer.disconnect();
    }, OBSERVER_MAX_MS);
  }

  function init(container) {
    if (!container || container.dataset.jdgmColorsApplied === 'true') return;
    container.dataset.jdgmColorsApplied = 'true';
    overrideAllColors(container);
    watchDynamicUpdates(container);
  }

  document.addEventListener('baybee:judgeme-reviews-loaded', function (event) {
    var container = (event.detail && event.detail.container) || document.getElementById('judgeme_product_reviews');
    init(container);
  });

  var loadedContainer = document.getElementById('judgeme_product_reviews');
  if (loadedContainer && loadedContainer.dataset.jdgmLoaded === 'true') {
    init(loadedContainer);
  }
})();
